import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../../lib/analytics';

/**
 * Dispara um pageview no dataLayer (`spa_pageview`) a cada troca de rota — exceto
 * no carregamento inicial, que já é contado pela Tag do Google (Initialization).
 * O pequeno setTimeout garante que o document.title já foi atualizado pelo Helmet
 * antes de ler o título.
 */
export default function RouteAnalytics() {
    const { pathname } = useLocation();
    const isFirst = useRef(true);

    useEffect(() => {
        if (isFirst.current) {
            isFirst.current = false;
            return;
        }
        const t = setTimeout(trackPageview, 0);
        return () => clearTimeout(t);
    }, [pathname]);

    return null;
}
